import { IJsonQuery } from '@cian/api-models/common/json_query';

export enum EResultsStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export interface IResultsState {
  status: EResultsStatus;
  version?: Symbol;
  subdomain: string;
  jsonQuery: IJsonQuery;
}
